/* The strip of screens at the top of a merged module (moduleTabsConfig.js says why and which). It is the module's
   own navigation, so it sits above the screen's title and reads as a level above the screen's own tabs
   (Waiting / Approved / Rates …): since 01/11 the portal's tab bar (ViewTabs.css, Max), the screen's own tabs stay pills.
   With only one screen open to the reader there is nothing to switch between, and no strip is drawn. */
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useAuth from './useAuth';
import { MODULES, tabActive, visibleTabs } from './moduleTabsConfig';
import TabIcon from './TabIcon';
import './ModuleTabs.css';

export default function ModuleTabs({ module }) {
    const { functions } = useAuth();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const can = (key) => Array.isArray(functions) && functions.includes(key);
    const tabs = visibleTabs(module, can);
    if (tabs.length < 2) return null;
    return (
        <nav className="mod-tabs view-tabs" aria-label={t(MODULES[module].labelKey)} data-testid={`mod-tabs-${module}`}>
            {tabs.map((tab) => {
                const on = tabActive(tab, pathname);
                return (
                    <button key={tab.key} type="button" className={`mod-tab ${on ? 'active' : ''}`}
                        aria-current={on ? 'page' : undefined} data-tab={tab.key}
                        onClick={() => { if (!on || pathname !== tab.path) navigate(tab.path); }}>
                        <TabIcon k={tab.key} />{t(tab.labelKey)}
                    </button>
                );
            })}
        </nav>
    );
}
